import {
    ApiClientFactory
} from '../ApiClientFactory';
import {
    API_V4_URL
} from '../Variables';

let clientFactory = new ApiClientFactory(API_V4_URL);

export const GuardianClient = {
    /**
     *
     * Returns a calendar with a given id
     */
    getLearners(guardian_id) {
        return clientFactory.get(`guardians/${guardian_id}/learners`);
    },

};